module.exports = __webpack_public_path__ + "static/media/light_fixture_DNAT.bfec089b.jpeg";